module.exports = __webpack_public_path__ + "static/media/noun_chat_2849584 (1).d204d20c.svg";